module.exports = __webpack_public_path__ + "fonts/GT-America-Standard-Regular.5b08b72f.woff2";